import useForm from '@base/Form/useForm';
import useOfflineCentresStore from '@stores/offline-centres';
import fetch from '@api/fetchers';
import { segment } from '@actions/analytics';
import { useEffect, useState } from 'react';
import { Offline_Post_Payment_Step_1_Landed } from '@constants/segment';
import { useSnackbar } from '@stores/snackbar';
import debounce from 'lodash/debounce';
import { getSubmitFormURL } from './apiHelper';
import FormHeading from './FormHeading';
import PersonalDetails from './PersonalDetails';
import LastClassDetails from './LastClassDetails';
import {
  BookAClassForm,
  ContinueButon,
  PostPaymentFormContainer,
  StyledDivider,
  StyledPaper,
  StyledStepHeading
} from './styles';
import UploadPhotos from './UploadPhotos';
import { modifyData, stepNumbers } from './utils';
import { DEFAULT_COUNTRY } from '../constants';

const PostPaymentForm = ({ formState, updateStoreData }) => {
  const { registrar, onFormSubmit } = useForm({
    data: formState
  });

  const { postPaymentForm, setPostPaymentFormState } = useOfflineCentresStore();
  const { rollNumber } = postPaymentForm;
  const { open: showSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmiiting] = useState(false);

  const updateFormSubmitted = debounce(() => {
    setIsSubmiiting(false);
  }, 1000);

  const onSubmit = async (data) => {
    const {
      candidateId,
      candidatePhoto,
      examCgpa,
      bloodGroup,
      parentFullName,
      parentPhoneNum,
      fullName,
      phoneNum,
      candidateMarksheet,
      candidateIdType,
      candidateIdNumber,
      parentIdType,
      parentId,
      parentIdNumber
    } = data;

    const updatedData = {
      candidateId: {
        name: candidateId?.name,
        public_url: candidateId?.public_url
      },
      candidatePhoto: {
        name: candidatePhoto?.name,
        public_url: candidatePhoto?.public_url
      },
      candidateMarksheet: {
        name: candidateMarksheet?.name,
        public_url: candidateMarksheet?.public_url
      },
      parentId: {
        name: parentId?.name,
        public_url: parentId?.public_url
      },
      bloodGroup: bloodGroup?.value,
      candidateIdType: candidateIdType?.value,
      parentIdType: parentIdType?.value,
      class: data.class?.value,
      examCgpa,
      parentFullName,
      parentPhoneNum,
      parentIdNumber,
      candidateIdNumber,
      fullName,
      phoneNum
    };

    const body = {
      'form-type': 1,
      'form-details': { ...updatedData }
    };
    setIsSubmiiting(true);
    fetch(getSubmitFormURL(), {
      useCamelCase: false,
      requestType: 'POST',
      body
    })
      .then(async (res) => {
        if (res?.form_data) {
          const modifiedData = modifyData(res.form_data);
          setPostPaymentFormState({
            ...modifiedData,
            stepNum: stepNumbers.TWO
          });
        } else {
          const errorResponse = res?.error;
          showSnackbar({
            message:
              errorResponse?.message ||
              'Something went wrong. Please try again.',
            type: 'error'
          });
        }
      })
      .catch(() => {
        showSnackbar({
          message: 'Something went wrong. Please try again.',
          type: 'error'
        });
      })
      .finally(updateFormSubmitted());
  };

  useEffect(() => {
    if (rollNumber) {
      segment.track(Offline_Post_Payment_Step_1_Landed, {
        roll_number: rollNumber
      });
    }
  }, [rollNumber]);
  const handleOnSubmit = onFormSubmit(onSubmit);
  return (
    <PostPaymentFormContainer>
      <StyledPaper>
        <BookAClassForm $display>
          <FormHeading rollNumber={formState.rollNumber} />
          <StyledDivider />
          <StyledStepHeading>Step 1 of 2</StyledStepHeading>
          <PersonalDetails
            registrar={registrar}
            country={DEFAULT_COUNTRY}
            updateStoreData={updateStoreData}
          />
          <UploadPhotos
            registrar={registrar}
            country={DEFAULT_COUNTRY}
            updateStoreData={updateStoreData}
          />
          <LastClassDetails
            registrar={registrar}
            updateStoreData={updateStoreData}
          />
          <ContinueButon
            onClick={handleOnSubmit}
            width="100%"
            variant={isSubmitting ? 'disabled' : 'filled'}
            label="Continue"
            color="black"
          />
        </BookAClassForm>
      </StyledPaper>
    </PostPaymentFormContainer>
  );
};

export default PostPaymentForm;
